module.exports = __webpack_public_path__ + "static/media/v_push-services-pa1.75692c87.png";